/**
 * weirwood的选项
 */

import * as Weirwood from '@baidu/weirwood-sdk';
import WeirwoodInfo from './weirwood.json';

const ignoreUrls = [
    // 本地开发屏蔽错误发送
    'localhost',
    '127.0.0.1'
];

export default {
    install(app, needWeirwood) {
        if (!needWeirwood) {
            return;
        }

        const weirwoodOptions = {
            // 通用选项
            common: {
                // 只支持如下字符：英文字母(大小写)，数字(0-9)，下划线(_)，中划线(-)，点(.)，@符号
                buildid: WeirwoodInfo.buildid,
                token: WeirwoodInfo.token,
                ignoreUrls
            },
            // 错误监控选项，优先级高于通用参数配置
            error: {
                collectWindowErrors: true,
                // promise异常
                collectUnhandledRejections: true,
                // 静态资源加载异常
                collectResourceLoadErrors: true,
                ignoreUrls
            },
            // 性能监控选项，优先级高于通用参数配置
            perf: {
                sampleRate: 0,
                spa: true,
                history: true,
                ignoreUrls,
                disable: true
            }
        };

        const weirwood = Weirwood.init(weirwoodOptions);
        // 核心：Hook Vue 的错误方法，调用 'weirwood' 的 'captureException' 方法
        app.config.errorHandler = err => {
            weirwood.error.captureException(err);
        };
    }
};
